import NotFoundPage from '@/views/General/NotFoundPage.vue';
import pages from './pages';
import dashboard from './dashboard';

export default [
  pages,
  dashboard,
  {
    // path: '/:catchAll(.*)',
    path: '/:catchAll(.*)*',
    name: '404',
    component: NotFoundPage,
  },
];
